import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  cartItemsHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    borderBottom: `1px solid ${colors.neutral[300]}`,
    paddingBottom: '1.6rem',
    flexDirection: 'column',
  },
  cartItemsTitle: {
    font: {
      size: '2.4rem',
      lineHeight: '3.2rem',
      weight: 700,
    },
    display: 'flex',
    alignItems: 'middle',
    margin: { top: 0, bottom: '0.4rem' },
    color: colors.neutral[900],
  },
  titleText: { marginLeft: '0.8rem' },
  cartItemsCaption: {
    margin: 0,
    marginRight: '1rem',
    font: { size: '1.8rem', lineHeight: '2.4rem', weight: 500 },
    color: colors.neutral[600],
  },
  checkboxLabel: { textTransform: 'uppercase', font: { weight: 500 } },
  inActiveCheckboxLabel: { color: colors.neutral[400] },
  actionButton: {
    textTransform: 'uppercase',
    marginBottom: '1.6rem',
    '&:last-of-type': {
      marginBottom: 0,
    },
  },
  titleWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  infoWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '1.6rem',
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
